import { serviceRequest } from './service-request';

export function getAgentPayload() {
	return serviceRequest('svc/pendo/agent-payload', null, { method: 'GET' });
}
